<template>
  <b-modal
    :ref="modalBodyID"
    body-class="vue-generic-modal"
    hide-footer
    hide-header
    :size="modalSize"
  >
    <div :id="modalBodyID"></div>
  </b-modal>
</template>

<script>
export default {
  methods: {
    openModal: async function() {
      await this.$refs[this.modalBodyID].show()
    },
    closeModal: async function() {
      await this.$refs[this.modalBodyID].hide()
      window.session.activeWindow.toggleLoading()
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      window.session.activeWindow.toggleLoading()
    })
  },
  props: {
    modalBodyID: {
      type: String,
    },
    modalTitle: {
      type: String,
    },
    modalSize: {
      type: String,
    },
  },
}
</script>
